import { render, staticRenderFns } from "./WelcomeMain.vue?vue&type=template&id=c6dd6d18&"
import script from "./WelcomeMain.vue?vue&type=script&lang=js&"
export * from "./WelcomeMain.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeMain.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports